import { curry, keys, reduce } from 'ramda';

export default curry((keysMap, obj) => {
  return reduce(
    (acc, key) => {
      acc[keysMap[key] || key] = obj[key];
      return acc;
    },
    {},
    keys(obj)
  );
});
